module.exports = __webpack_public_path__ + "static/img/zhengfu-link.3a9e0f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhengfu-link.jpg
// module id = uE7t
// module chunks = 1